module.exports = __webpack_public_path__ + "img/frame13_stamp.bf3d0a4e.png";